import ProgramsList from './ProgramsList'
import ProgramsSingle from './ProgramsSingle'
import ProgramsSingleDetails from './ProgramsSingleDetails'
import ProgramsSingleGraduates from './ProgramsSingleGraduates'
import ProgramsSingleUploadDocuments from './ProgramsSingleUploadDocuments'
import ProgramsSingleManagerAssignments from './ProgramsSingleManagerAssignments'
import ProgramsSingleResources from './ProgramsSingleResources'

export default {
  ProgramsList,
  ProgramsSingle,
  ProgramsSingleDetails,
  ProgramsSingleGraduates,
  ProgramsSingleUploadDocuments,
  ProgramsSingleManagerAssignments,
  ProgramsSingleResources
}
